module.exports = __webpack_public_path__ + "img/icon_attribute_cool_64.64ff2587.png";